import { useQuery } from '@tanstack/react-query';
import { customerApiEndpoints, qzTrayApiEndpoints } from '@/api/endpoints';

export function useUsers() {
  return useQuery({
    querykey: ['user-list'],
    queryFn: async () => {
      const { data } = await customerApiEndpoints.retrieveList();
      return data;
    },
  });
}

export function useQzTraySetup() {
  return useQuery({
    querykey: ['qz-tray-list'],
    queryFn: async () => {
      const { data } = await qzTrayApiEndpoints.retrieveList();
      return data;
    },
  });
}
